module.exports = __webpack_public_path__ + "static/media/firstPortfolio.6e88e9d5.png";